import * as React from 'react'

import { authRef } from 'config/firebase'

import firebase from 'firebase/app'
import mixpanel from 'mixpanel-browser'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { clearPlusUser } from 'services/plusUsers'
import { getCustomToken } from 'services/user'
import * as PlusUserActions from 'store/plusUsers/actions'
import * as AuthUserActions from '../../store/authUser/actions'
import * as UserActions from '../../store/user/actions'

/**
 * `null` - non-authosized
 *
 * `undefined` - not ininitialized (waiting for promise resolve)
 */
export type AuthUser = firebase.User | null | undefined

interface INativeProps {}

interface IReduxProps {
  user: any
  UserLib: any
  PlusUserLib: any
  AuthUserLib: {
    setAuthUser: (authUser: AuthUser) => void
  }
}

interface IProps extends INativeProps, IReduxProps {}

interface IState {
  authUser: AuthUser
}

export const withAuthentication = (Component: React.ElementType<any>) => {
  class WithAuthentication extends React.Component<IProps, IState> {
    private listener: firebase.Unsubscribe | null

    constructor(props: any) {
      super(props)
      this.state = {
        authUser: undefined
      }
      this.listener = null
    }

    componentDidMount() {
      const { UserLib, user, PlusUserLib, AuthUserLib } = this.props

      this.listener = authRef.onAuthStateChanged(
        (authUser: firebase.User | null) => {
          this.setState({ authUser })
          if (!authUser && user.data) {
            UserLib.logout()
            clearPlusUser(PlusUserLib)
          }

          if (authUser) {
            // ability to send data to game app
            getCustomToken().then(res => {
              if (!res.data) {
                UserLib.logout()
              }

              // !mixpanel stuff needed to be separated into appropriate action
              mixpanel.alias(authUser.uid)
              mixpanel.get_distinct_id()
              mixpanel.people.set({
                ID: authUser.uid,
                $name: authUser.displayName,
                $email: authUser.email,
                $created:
                  authUser.metadata.creationTime &&
                  new Date(authUser.metadata.creationTime).getTime()
              })
              // *should call user.identify after every `people.set`, check documentation for more details
              mixpanel.identify(authUser.uid)

              // window.location.href = 'uniwebview://action?token=' + res.data
            })
          }
          AuthUserLib.setAuthUser(authUser)
        }
      )
    }

    componentWillUnmount() {
      if (this.listener) {
        this.listener()
      }
    }

    render() {
      return <Component {...this.props} />
    }
  }

  const mapStateToProps = state => ({ user: state.user })
  const mapDispatchToProps = dispatch => ({
    AuthUserLib: bindActionCreators(AuthUserActions, dispatch),
    UserLib: bindActionCreators<any, any>(UserActions, dispatch),
    PlusUserLib: bindActionCreators(PlusUserActions, dispatch)
  })

  const Connected = connect(
    mapStateToProps,
    mapDispatchToProps
  )(WithAuthentication)

  return (props: INativeProps) => <Connected {...props} />
}



// WEBPACK FOOTER //
// ./src/components/Session/withAuthentication.tsx